<!--
<div class="card">
  <h5>Left Align</h5>
  <p-timeline [value]="gfg">
    <ng-template pTemplate="content" let-event>
      {{event.status}}
    </ng-template>
  </p-timeline>
</div>

<div class="card">
  <h5>Right Align</h5>
  <p-timeline [value]="gfg" align="right">
    <ng-template pTemplate="content" let-event>
      {{event.status}}
    </ng-template>
  </p-timeline>
</div>
-->
<!-- <div class="card"> -->
  <!-- <h5>Alternate Align</h5> -->
  <p-timeline [value]="liveTimeLineData" align="alternate">
    <ng-template pTemplate="content" let-event>
      <div class="message" style="font-size: 0.9rem;"><strong>{{ event.message }}</strong></div>
      <!-- @if (event.enteredBy && !event.enteredBy.includes(sureSimName)) { -->
        <div class="enteredBy" style="font-size: 0.8rem;">by {{ event.enteredBy.replace("System", "").trim() }}</div>
      <!-- } -->
      <div class="enteredDate" style="font-size: 0.75rem; color: gray;">{{ event.enteredDate | date:'dd-MM-yyyy HH:mm:ss':'UTC' }}</div>
    </ng-template>
  </p-timeline>
<!-- </div> -->
